import { InputBase } from '@mui/material';
import { styled } from '@mui/system';
import colors from '../../assets/colors';

const CustomInput = styled(InputBase)(({ theme }) => ({
  'label + &': {
    marginTop: theme.spacing(1),
  },
  '& 	.MuiInputBase-input': {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: colors.white,
    border: `1px solid ${colors.oldAgroweGreen}`,
    fontSize: 18,
    padding: '18px 18px 18px 12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    '&:focus': {
      borderRadius: 6,
      borderColor: colors.oldAgroweGreen,
    },
  },
}));

export default CustomInput;
